import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { SearchReportBanner } from '@ltvco/refresh-lib/fmt';
import { useReportRedirect } from '@ltvco/refresh-lib/v1';
import {
  CollectionType,
  FeatureBlockedModal,
  useFeatureBlockedModal,
  type NullableAdvancedSearchURLParams,
} from '@ltvco/refresh-lib/v2';
import { useState } from 'react';

import imgObituarySearchBanner from 'images/imgObituarySearchBanner.svg';

interface SearchBannerProps {
  searchParams: NullableAdvancedSearchURLParams;
}

export function ObituarySearchBanner({ searchParams }: SearchBannerProps) {
  const { redirectToSearchPersonUrlv2 } = useReportRedirect();
  const { isBlocked } = useSubscriptionAccessConfigContext();
  const {
    isFeatureBlockedModalOpen,
    openFeatureBlockedModal,
    closeFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const [searchType, setSearchType] = useState<string>('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);

  const isDeceased: boolean | undefined =
    !!searchParams.deathYear ||
    (searchParams.birthYear && parseInt(searchParams.birthYear) < 1925)
      ? true
      : undefined;

  const personInfo: NullableAdvancedSearchURLParams = {
    ...searchParams,
    isDeceased,
    advancedSearch: true,
    source: [CollectionType.OBITUARIES],
  };

  const displayName = searchParams.fName || searchParams.lName || 'this person';

  const handleClick = () => {
    if (isBlocked('obituary')) {
      setSearchType('Obituary');
      openFeatureBlockedModal();
      return;
    }

    redirectToSearchPersonUrlv2(personInfo);
  };

  return (
    <>
      <SearchReportBanner
        title={`Look for ${displayName}'s Obituary`}
        description="Find out more about their story."
        buttonText="Search Obituary"
        imageSrc={imgObituarySearchBanner}
        isDeceased={isDeceased}
        onButtonClick={handleClick}
      />

      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
}
